import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import NewReleases from "./components/NewReleases";
import ExclusiveSection from "./components/ExclusiveSection";
import RankingSection from "./components/RankingSection";
import CategorySection from "./components/CategorySection";
import TestimonialSection from "./components/TestimonialSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <NewReleases />
        <ExclusiveSection />
        <RankingSection />
        <CategorySection />
        <TestimonialSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "叮咚漫画网",
            description: "叮咚漫画网新作首发/独家抢先看/新番上架速递，第一时间上架新作与独家内容。",
            url: "https://fangupdate.github.io/",
            inLanguage: "zh-CN",
            mainEntity: {
              "@type": "ItemList",
              itemListElement: [
                { "@type": "ListItem", position: 1, name: "守护之星" },
                { "@type": "ListItem", position: 2, name: "剑仙风云录" },
                { "@type": "ListItem", position: 3, name: "机甲纪元" },
                { "@type": "ListItem", position: 4, name: "幕后黑手" },
                { "@type": "ListItem", position: 5, name: "天使的邂逅" },
                { "@type": "ListItem", position: 6, name: "豆比日记" },
              ],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "叮咚漫画网的新作多久更新一次？",
                acceptedAnswer: { "@type": "Answer", text: "叮咚漫画网坚持每日更新新作列表，热门新番与独家内容会第一时间上架速递。" },
              },
              {
                "@type": "Question",
                name: "独家抢先看的作品和其他网站有什么不同？",
                acceptedAnswer: { "@type": "Answer", text: "叮咚漫画网的独家内容意味着你在其他平台无法率先看到，更新进度通常领先全网。" },
              },
              {
                "@type": "Question",
                name: "如何第一时间收到新番上架提醒？",
                acceptedAnswer: { "@type": "Answer", text: "订阅叮咚漫画网新作资讯邮件，每次新番上架或独家首发时第一时间推送提醒。" },
              },
              {
                "@type": "Question",
                name: "作品更新进度在哪里查看？",
                acceptedAnswer: { "@type": "Answer", text: "每部作品的详情页都会展示最新章节、更新时间和连载状态。" },
              },
            ],
          }),
        }}
      />
    </>
  );
}